import Swal from 'sweetalert2';

/**
 * Configuración por defecto para SweetAlert2
 */
const defaultConfig = {
  confirmButtonColor: '#3B82F6', // primary-600
  cancelButtonColor: '#6B7280', // secondary-500
  confirmButtonText: 'Aceptar',
  cancelButtonText: 'Cancelar',
};

/**
 * Muestra un alert de éxito
 */
export const showSuccess = (title: string, message?: string) => {
  return Swal.fire({
    icon: 'success',
    title,
    text: message,
    confirmButtonColor: defaultConfig.confirmButtonColor,
    confirmButtonText: defaultConfig.confirmButtonText,
  });
};

/**
 * Muestra un alert de error
 */
export const showError = (title: string, message?: string) => {
  return Swal.fire({
    icon: 'error',
    title,
    text: message,
    confirmButtonColor: defaultConfig.confirmButtonColor,
    confirmButtonText: defaultConfig.confirmButtonText,
  });
};

/**
 * Muestra un alert de advertencia
 */
export const showWarning = (title: string, message?: string) => {
  return Swal.fire({
    icon: 'warning',
    title,
    text: message,
    confirmButtonColor: defaultConfig.confirmButtonColor,
    confirmButtonText: defaultConfig.confirmButtonText,
  });
};

/**
 * Muestra un alert de información
 */
export const showInfo = (title: string, message?: string) => {
  return Swal.fire({
    icon: 'info',
    title,
    text: message,
    confirmButtonColor: defaultConfig.confirmButtonColor,
    confirmButtonText: defaultConfig.confirmButtonText,
  });
};

/**
 * Muestra un diálogo de confirmación
 */
export const showConfirm = (title: string, message?: string) => {
  return Swal.fire({
    icon: 'question',
    title,
    text: message,
    showCancelButton: true,
    confirmButtonColor: defaultConfig.confirmButtonColor,
    cancelButtonColor: defaultConfig.cancelButtonColor,
    confirmButtonText: defaultConfig.confirmButtonText,
    cancelButtonText: defaultConfig.cancelButtonText,
  });
};

/**
 * Muestra un loading/spinner
 */
export const showLoading = (title: string, message?: string) => {
  return Swal.fire({
    title,
    text: message,
    allowOutsideClick: false,
    allowEscapeKey: false,
    didOpen: () => {
      Swal.showLoading();
    },
  });
};

/**
 * Cierra el SweetAlert actual
 */
export const closeAlert = () => {
  Swal.close();
};

/**
 * Muestra un toast (notificación pequeña)
 */
export const showToast = (icon: 'success' | 'error' | 'warning' | 'info', title: string) => {
  const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer);
      toast.addEventListener('mouseleave', Swal.resumeTimer);
    },
  });

  return Toast.fire({
    icon,
    title,
  });
};
